import React from 'react';

const ChristmasDecorations = () => (
  <>
    <div className="christmas-garland-left" />
    <div className="christmas-garland-right" />
  </>
);

export default ChristmasDecorations;
